import type { WiwState } from '@/store';

export const getIncludeChildAccounts = (state: WiwState): boolean | undefined =>
  state.reporting.customReportBuilder.includeChildAccounts;
